import React from 'react';
import { PropTypes } from 'prop-types';
import { connect } from 'react-redux';
import { injectIntl, FormattedHTMLMessage } from 'react-intl';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import CustomerAvatar from 'components/CustomerAvatar';

import ConnectionStatus from 'components/Common/ConnectionStatus';
import MenuMobile from 'components/MenuMobile';
import PoweredBy from 'components/PoweredBy';
// import LanguageSelector from 'components/LanguageSelector';

const contains = (intl, messageId) => intl && !!intl.messages[messageId];

const Header = ({ dispatch, intl, isAuthenticated, languages, showMenu, isLogoutEnabled, isOnline }) => <header className={ `header ${ isOnline ? '' : 'offline' }` }>
  <div className="row m-0">
    <div className="row m-0 col-2 col-sm-3 col-md-4">
      <div className="col-md-2 p-0">
        { !isLogoutEnabled && isAuthenticated && <Link to="/form-selection" className="btn btn-link">
          <FontAwesomeIcon icon="home" size="lg" />
        </Link>}
        { isAuthenticated && isLogoutEnabled && showMenu && <MenuMobile showLogout={ isAuthenticated && isLogoutEnabled } /> }
      </div>
      { isAuthenticated && <CustomerAvatar />}
    </div>
    <div className="col-8 col-sm-6 col-md-4 logo">
      <div className="logo" id="taina-logo" />
      <PoweredBy />
    </div>
    <div className="col-2 col-sm-3 col-md-4 text-right">
      { contains(intl, 'footerPage.help') && <a href={ intl.messages['footerPage.help'] } target="_blank" rel="noopener noreferrer" className="help-link" title="Help, opens in a new window">
        <FontAwesomeIcon icon="question-circle" size="2x" />
      </a> }
      { /* languages && <LanguageSelector languages={ languages } /> */ }
    </div>
  </div>
  <ConnectionStatus><FormattedHTMLMessage id="noInternet.banner.content" /></ConnectionStatus>
</header>;

Header.propTypes = {
  dispatch: PropTypes.func.isRequired,
  intl: PropTypes.shape({
    messages: PropTypes.any
  }).isRequired,
  isAuthenticated: PropTypes.bool.isRequired,
  languages: PropTypes.arrayOf(
    PropTypes.shape({
      key: PropTypes.string,
      value: PropTypes.string
    })
  ),
  showMenu: PropTypes.bool,
  isLogoutEnabled: PropTypes.bool,
  isOnline: PropTypes.bool
};

Header.defaultProps = {
  languages: [{
    key: 'en',
    value: 'English'
  }],
  isLogoutEnabled: false,
  isOnline: true,
  showMenu: true,
};

const mapDispatchToProps = dispatch => ({ dispatch });

function mapStateToProps(state, ownProps) {
  const {
    app: {
      isAuthenticated,
      languages,
      onlineConfig,
      isOnline
    }
  } = state;

  return {
    isAuthenticated,
    isOnline,
    languages,
    isLogoutEnabled: onlineConfig && onlineConfig.isLogoutEnabled
  };
}

export default injectIntl(connect(
  mapStateToProps,
  mapDispatchToProps
)(Header));
